import React, { useState, useEffect } from "react";
import {
  Button,
  FormControl,
  FormLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
  FormControlLabel,
  Radio,
  RadioGroup,
} from "@material-ui/core";
import useStyles from "../../../../styles";
import axios from "axios";
import { decryptData } from "../../../../crypto";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import { useNavigate } from "react-router-dom";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import instructioncontent from "./instructioncontent";
import instructioncontentJeeMain from "./instructioncontentJeeMain";
import instructioncontentSsc from "./instructioncontentSsc";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { getSlotListData } from "../../../../service/services";
import { getMarkListData } from "../../../../service/MarkingServices";
import { getCourseData } from "../../../../service/ExamServices";
import * as Yup from "yup";
import { sanitizeInput } from "../../../../Utils/validationUtils";

//scema of the form validation
// const examValidationSchema = Yup.object().shape({
//   exam_name: Yup.string().trim().required("Please enter an exam name."),
//   course_id: Yup.string().required("Please select a course."),
//   batch_id: Yup.string().required("Please select a batch."),
//   subjects: Yup.array().min(1, "Please select at least one subject."),
//   center_id: Yup.array().min(1, "Please select at least one center."),
//   language: Yup.array().min(1, "Please select at least one language."),
//   question_count: Yup.number()
//     .typeError("Please enter the number of questions.")
//     .required("Please enter the number of questions."),
//   total_score: Yup.number()
//     .typeError("Please enter the total score.")
//     .required("Please enter the total score."),
//   negative_marking: Yup.string(),
//   negative_marking_score: Yup.number().when("negative_marking", {
//     is: "yes",
//     then: (schema) =>
//       schema
//         .moreThan(0, "Please add a Negative Marking greater than 0.")
//         .required("Please add a Negative Marking."),
//     otherwise: (schema) => schema.notRequired(),
//   }),
//   exam_pin: Yup.string().required("Please enter the exam pin."),
//   duration: Yup.number()
//     .typeError("Please enter the duration of the exam.")
//     .required("Please enter the duration of the exam."),
//   start_date: Yup.string().required("Please select a start date."),
//   start_time: Yup.string().required("Please select a start time."),
//   exam_template: Yup.string().required("Please select an exam template."),
// });
// ReactQuill Modules and Formats
const quillModules = {
  toolbar: [
    [
      "bold",
      "italic",
      "underline",
      "strike",
      { script: "sub" },
      { script: "super" },
      { color: [] },
      { background: [] },
    ],
    [{ list: "ordered" }, { list: "bullet" }],
    ["link", "image"],
    ["code-block"],
  ],
};

const quillFormats = [
  "header",
  "font",
  "size",
  "list",
  "bold",
  "italic",
  "underline",
  "strike",
  "color",
  "background",
  "script",
  "link",
  "blockquote",
  "code-block",
  "align",
  "image",
];

// function for Convert Image In Base64

const convertImageToBase64 = async (url) => {
  const response = await axios.get(url, { responseType: "blob" });
  const blob = response.data;
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
};

// Form InitialData
const initialData = {
  center_id: "",
  course_id: "",
  batch_id: "",
  exam_name: "",
  language: ["en"],
  question_count: "",
  total_score: "",
  question_shuffle: "no",
  negative_marking: "no",
  negative_marking_score: "0",
  exam_instant_result: "no",
  exam_pin: "",
  exam_template: "default",
  exam_instructions: {
    en: "",
    hi: "",
  },
  genral_instruction: {
    en: "",
    hi: "",
  },
  duration: "",
  start_date: "",
  start_time: "",
  slot_value: "",
  marking_system: "",
  file: null,
};
// Menu Props for Fields
const menuProps = {
  getContentAnchorEl: null,
  anchorOrigin: {
    vertical: "bottom",
    horizontal: "left",
  },
  disablePortal: true,
};

function AddFeedbackForm() {
  const classes = useStyles();
  const navigate = useNavigate();
  const decryptedToken = decryptData(sessionStorage.getItem("token"));
  const [questionMarkSystem, setQuestionMarkSystem] = useState("same");
  const [formDetails, setFormDetails] = useState(initialData);
  const [examName, setExamName] = useState("");
  const [perQuestionMarks, setPerQuestionMarks] = useState("0");
  const [languageMenuOpen, setLanguageMenuOpen] = useState(false);
  const [center, setCenter] = useState([]);
  const [selectedCenter, setSelectedCenter] = useState("");
  const [courses, setCourses] = useState([]);
  const [selectedCourse, setSelectedCourse] = useState([]);
  const [batches, setBatches] = useState([]);
  const [selectedBatch, setSelectedBatch] = useState("");
  const [subjects, setSubjects] = useState([]);
  const [selectedSubject, setSelectedSubject] = useState([]);
  const [thumbnailImage, setThumbnailImage] = useState(null);
  const [showSubjectWiseDuration, setShowSubjectWiseDuration] = useState("no");
  const [slotDropdownFieldData, setSlotDropdownFieldData] = useState([]);
  const [examTempalteData, setExamTemplateData] = useState([]);
  const [subjectDurations, setSubjectDurations] = useState([]);
  const [loading, setLoading] = useState(false);

  // console.log('selectedCourse',selectedCourse)

  useEffect(() => {
    const convertAllImagesToBase64 = async (htmlContent) => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(htmlContent, "text/html");
      const imgTags = doc.querySelectorAll("img");

      for (const img of imgTags) {
        const src = img.getAttribute("src");
        if (src && !src.startsWith("data:")) {
          const base64 = await convertImageToBase64(src);
          img.setAttribute("src", base64);
        }
      }

      return doc.body.innerHTML;
    };
    const handleInstructions = async () => {
      if (!formDetails.exam_template) return;

      let selectedInstructions;
      switch (formDetails.exam_template.toLowerCase()) {
        case "iit":
          selectedInstructions = {
            en: instructioncontentJeeMain.en,
            hi: instructioncontentJeeMain.hi,
          };
          break;
        case "ssc/railway":
          selectedInstructions = {
            en: instructioncontentSsc.en,
            hi: instructioncontentSsc.hi,
          };
          break;
        default:
          selectedInstructions = {
            en: instructioncontent.en,
            hi: instructioncontent.hi,
          };
      }

      const [en, hi] = await Promise.all([
        convertAllImagesToBase64(selectedInstructions.en),
        convertAllImagesToBase64(selectedInstructions.hi),
      ]);
      setFormDetails((prev) => ({
        ...prev,
        exam_instructions: { en, hi },
      }));
    };

    handleInstructions();
  }, [formDetails.exam_template]);

  useEffect(() => {
    const fetchSlots = async () => {
      if (!decryptedToken) return;

      try {
        // const [markListData, slotListData, courseData] = await Promise.all([
        //   getMarkListData(),
        //   getSlotListData(),
        //   getCourseData(),
        // ]);
        const res = await getCourseData();
        console.log("Check", res?.courses);
        // setExamTemplateData(markListData?.markingsystem || []);
        // setSlotDropdownFieldData(slotListData || []);
        if (res?.courses) {
          setCourses(res?.courses || []);
        }
      } catch (err) {
        console.error("Failed to load slots:", err);
      }
    };
    fetchSlots();
  }, []);

  useEffect(() => {
    fetchCenter();

    fetchSubjects();

    if (selectedCourse) {
      fetchBatches(selectedCourse);
    }
  }, [selectedCourse, selectedBatch]);

  //For Change The Subject Wise Duration Of Each Field
  const handleSubjectDurationChange = (subjectId, value) => {
    setSubjectDurations((prev) => {
      const existingIndex = prev.findIndex(
        (item) => item.subject_id === subjectId,
      );

      if (existingIndex >= 0) {
        const updated = [...prev];
        updated[existingIndex] = {
          ...updated[existingIndex],
          duration: parseInt(value),
        };
        return updated;
      } else {
        return [...prev, { subject_id: subjectId, duration: parseInt(value) }];
      }
    });
  };

  const handleLanguageMenuToggle = () => {
    setLanguageMenuOpen(!languageMenuOpen);
  };

  const handleFormChange = (fieldName, value) => {
    if (fieldName === "end_time") {
      if (formDetails.start_time && value && value <= formDetails.start_time) {
        toast.warn("End time must be after start time.");
        setFormDetails((prev) => ({
          ...prev,
          end_time: "",
        }));
        return;
      }
    }

    if (fieldName === "start_time") {
      if (formDetails.end_time && value && formDetails.end_time <= value) {
        toast.warn("Start time cannot be after end time. Please reselect end time.");
        setFormDetails((prev) => ({
          ...prev,
          start_time: value,
          end_time: "",
        }));
        return;
      }
    }

    const updatedForm = {
      ...formDetails,
      [fieldName]:
        fieldName === "language" && typeof value === "string"
          ? value.split(",")
          : value,
    };
    if (updatedForm.question_count && updatedForm.total_score) {
      const calculated = updatedForm.total_score / updatedForm.question_count;
      setPerQuestionMarks(calculated.toFixed(2));
    }
    if (fieldName === "language") {
      const languages = updatedForm.language;
      const newInstructions = { ...formDetails.exam_instructions };
      const newGeneralInstructions = { ...formDetails.genral_instruction };
      languages.forEach((lang) => {
        if (!newInstructions[lang]) {
          newInstructions[lang] = "";
        }
        if (!newGeneralInstructions[lang]) {
          newGeneralInstructions[lang] = "";
        }
      });
      setFormDetails((prev) => ({
        ...prev,
        [fieldName]: languages,
        exam_instructions: newInstructions,
        genral_instruction: newGeneralInstructions,
      }));
    } else {
      setFormDetails((prev) => {
        const newForm = { ...prev, [fieldName]: value };
        if (fieldName === "question_mark_system" && value === "different") {
          newForm.negative_marking = "no";
        }
        return newForm;
      });
    }
  };
  const handleQuestionMarkSystemChange = (event) => {
    setShowSubjectWiseDuration(event.target.value);
  };

  // const handleQuestionMarkSystemChange = (event) => {
  //   setShowSubjectWiseDuration(event.target.value);
  // };

  const handleCourceChange = (event) => {
    setSelectedCourse(event.target.value);
  };

  const handleBatchChange = (event) => {
    setSelectedBatch(event.target.value);
  };

  const handleSubjectChange = (event, newValue) => {
    const selectedIds = newValue.map((subject) => subject.id);
    setSelectedSubject(selectedIds);
    const newQuestionCount = selectedIds.length * 10;
    setFormDetails((prev) => {
      const updated = {
        ...prev,
        question_count: newQuestionCount,
        total_score: newQuestionCount,
      };
      if (updated.question_count && updated.total_score) {
        const calculated = updated.total_score / updated.question_count;
        setPerQuestionMarks(calculated.toFixed(2));
      } else {
        setPerQuestionMarks("0");
      }
      return updated;
    });
  };

  const handleCenterChange = (event, newValue) => {
    setSelectedCenter(newValue.map((center) => center.id));
  };

  const handleCancel = () => {
    navigate("/admin/feedback");
  };

  function isDecimal(num) {
    const decimal = num % 1;
    return decimal !== 0;
  }

  const handleFormSubmit = async () => {
    if (!examName.trim()) {
      toast.warn("Please enter an exam name.");
      return;
    }

    if (!selectedCourse) {
      toast.warn("Please select a course.");
      return;
    }

    if (!selectedBatch || batches?.length === 0) {
      toast.warn("Please select a batch.");
      return;
    }

    if (
      !selectedSubject ||
      selectedSubject.length === 0 ||
      subjects?.length === 0
    ) {
      toast.warn("Please select at least one Faculty.");
      return;
    }

    if (!selectedCenter || selectedCenter.length === 0) {
      toast.warn("Please select at least one center.");
      return;
    }

    if (!formDetails.language || formDetails.language.length === 0) {
      toast.warn("Please select at least one language.");
      return;
    }

    if (!formDetails.question_count) {
      toast.warn("Please enter the number of questions.");
      return;
    }

    if (!formDetails.total_score) {
      toast.warn("Please enter the total score.");
      return;
    }
    if (showSubjectWiseDuration === "yes") {
      // Check if durations are provided for all selected subjects
      if (subjectDurations.length !== selectedSubject.length) {
        toast.warn("Please enter duration for all selected subjects.");
        return;
      }

      // Check each subject duration
      const invalidSubjects = [];
      subjectDurations.forEach((item) => {
        if (isNaN(item.duration) || item.duration <= 0) {
          const subject = subjects.find((sub) => sub.id === item.subject_id);
          if (subject) invalidSubjects.push(subject.subject_name);
        }
      });

      if (invalidSubjects.length > 0) {
        toast.warn(
          `Please enter valid duration for: ${invalidSubjects.join(", ")}`,
        );
        return;
      }
    }
    if (
      formDetails.negative_marking == "yes" &&
      (formDetails.negative_marking_score.length === 0 ||
        formDetails.negative_marking_score == -0)
    ) {
      if (formDetails.negative_marking_score == -0) {
        toast.warn("Please Add a Negetive Marking Grater Then 0.");
      } else {
        toast.warn("Please Add a Negetive Marking.");
      }
      return;
    }
    if (!formDetails.exam_pin) {
      toast.warn("Please enter the exam pin.");
      return;
    }

    if (!formDetails.duration) {
      toast.warn("Please enter the duration of the exam.");
      return;
    }

    if (!formDetails.start_date) {
      toast.warn("Please select a start date.");
      return;
    }

    if (!formDetails.start_time) {
      toast.warn("Please select a start time.");
      return;
    }
    if (!formDetails.end_time) {
      toast.warn("Please select a end time.");
      return;
    }
    if (formDetails.end_time <= formDetails.start_time) {
      toast.warn("End time must be after start time.");
      return;
    }
    if (!formDetails.exam_template) {
      toast.warn("Please select a Exam Template.");
      return;
    }
    // if (!formDetails.slot_value) {
    //   toast.warn("Please select a Slot.");
    //   return;
    // }
    // if (formDetails.negative_marking_score.length == 0) {
    //   toast.warn("Please Add a Negative Marking.");
    //   return;
    // }
    if (showSubjectWiseDuration === "yes") {
      if (subjectDurations.length !== selectedSubject.length) {
        toast.warn("Please enter duration for all selected subjects.");
        return;
      }

      const invalidSubject = subjectDurations.find(
        (item) => item.duration <= 0 || isNaN(item.duration),
      );

      if (invalidSubject) {
        toast.warn("Please enter valid duration for all subjects.");
        return;
      }
    }

    if (questionMarkSystem === "same" && isDecimal(perQuestionMarks)) {
      toast.warn(
        "Per Question Mark must be a whole number when the marking system is 'same'.",
      );
      return;
    }

    try {
      const formData = new FormData();
      const examData = {
        course_ids: selectedCourse,
        batch_ids: selectedBatch,
        subjects: selectedSubject,
        center_id: selectedCenter,
        exam_name: examName,
        language: formDetails.language.map((lang) =>
          lang === "en" ? "en" : "hi",
        ),
        question_count: formDetails.question_count,
        total_score: formDetails.total_score,
        per_question_mark: perQuestionMarks,
        question_shuffle: formDetails.question_shuffle,
        negative_marking: formDetails.negative_marking,
        negative_marking_score:
          formDetails.negative_marking === "no"
            ? "0"
            : formDetails.negative_marking_score,
        exam_instant_result: formDetails.exam_instant_result,
        exam_pin: formDetails.exam_pin,
        exam_instruction_en: formDetails.exam_instructions.en,
        exam_instruction_hi: formDetails.exam_instructions.hi,
        genral_instruction_en: formDetails.genral_instruction.en,
        genral_instruction_hi: formDetails.genral_instruction.hi,
        duration: formDetails.duration,
        start_date: formDetails.start_date,
        start_time: formDetails.start_time,
        end_time: formDetails.end_time,
        exam_template: formDetails.exam_template,
        question_mark_system: questionMarkSystem,
        marking_system_id: formDetails.marking_system || null,
        subject_wise: showSubjectWiseDuration || null,
        slot_id: formDetails.slot_value || null,
        subjectDuration:
          showSubjectWiseDuration === "yes" ? subjectDurations : [],
        exam_type: "demo",
        // end_time: "18:00:00",
      };
      console.log(examData, "CheckExamData");
      formData.append("exam", JSON.stringify(examData));
      formData.append("file", thumbnailImage);
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/exam/demo`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${decryptedToken}`,
            "Content-Type": "multipart/form-data",
          },
        },
      );

      if (response.status === 200) {
        toast.success("Feedback created successfully!");
        setTimeout(() => {
          navigate(`/admin/addfeedbackquestion/${response.data.exam.id}`);
        }, 2000);
      } else {
        // If the response status is not 200, handle it as an error
        toast.error(`Exam is not created! ${response.data.message}`);
      }
    } catch (error) {
      // Handling errors
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        // Display the error message from the API response
        toast.error(`Error: ${error.response.data.message}`);
      } else {
        // Generic error message for other types of errors
        toast.error(
          "An unexpected error occurred while creating the Feedback.",
        );
      }
      console.error("An error occurred:", error);
    }
  };

  const fetchBatches = async (selectedCourse) => {
    const data = {
      batch: {
        course_ids: selectedCourse,
      },
    };

    try {
      const response = await axios.post(
        // `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/batch/by_course_id/${selectedCourse}`,
        `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/batch/by_course_ids/list`,
        data,
        {
          headers: {
            Authorization: `Bearer ${decryptedToken}`,
          },
        },
      );
      if (response) {
        console.log("selectedCourse", response.data.batches);
        setBatches(response.data.batches);
      } else {
        console.error("Failed to fetch batches data:", response);
      }

      // if (response.data && response.data.batches) {
      //   setBatches(response.data.batches);
      // } else {
      //   console.error("Invalid API response format:", response);
      // }
    } catch (error) {
      console.error("Error fetching courses:", error);
    }
  };

  const fetchSubjects = async (selectedBatch) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/subject/active/list`,
        {
          headers: {
            Authorization: `Bearer ${decryptedToken}`,
          },
        },
      );
      if (response.data && response.data.subjects) {
        const filteredSubjects = (response.data.subjects || []).filter(
          (sub) => sub.type === "faculty"
        );
        // setSubjects(response.data.subjects);
        setSubjects(filteredSubjects);
      } else {
        console.error("Invalid API response format:", response);
      }
    } catch (error) {
      console.error("Error fetching courses:", error);
    }
  };

  const fetchCenter = async () => {
    try {
      const decryptedToken = decryptData(sessionStorage.getItem("token"));

      if (selectedCourse && selectedBatch) {
        const response = await axios.post(
          `${process.env.REACT_APP_API_BASE_URL}/v1/client/center/centers/course/batch`,
          {
            center: {
              courseId: selectedCourse,
              batchId: selectedBatch,
            },
          },
          {
            headers: {
              Authorization: `Bearer ${decryptedToken}`,
              "Content-Type": "application/json",
            },
          },
        );

        setCenter(response.data.response);
      }
    } catch (error) {
      console.error("Error fetching batches data:", error);
    }
  };

  const handleAutoGeneratePin = async () => {
    try {
      const decryptedToken = decryptData(sessionStorage.getItem("token"));
      setLoading(true);

      const res = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/exam/generate/unique/pin`,
        {
          headers: {
            Authorization: `Bearer ${decryptedToken}`,
          },
        },
      );

      handleFormChange("exam_pin", res.data?.exam_pin);
    } catch (error) {
      console.error(error);
      toast.error("Failed to generate exam pin");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <ToastContainer />
      <div
        className={`${classes.mt1}  ${classes.inputpadding} ${classes.inputborder} ${classes.pagescroll} ${classes.h72vh}`}
      >
        <FormControl className={`${classes.w100}`}>
          <div
            className={`${classes.bgwhite} ${classes.boxshadow3} ${classes.borderradius6px} ${classes.py2} ${classes.px1_5}`}
          >
            <div className={`${classes.dflex} ${classes.justifyspacebetween} `}>
              <Typography
                className={`${classes.w24} ${classes.textcolorformhead} ${classes.fontfamilyoutfit} ${classes.fontsize} ${classes.fontstylenormal} ${classes.fw500} ${classes.lineheight2_25}`}
                variant="h6"
                display="inline"
              >
                Feedback Details
              </Typography>
              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w24}`}
              >
                <FormLabel
                  className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                >
                  Feedback Name <span className={classes.textcolorred}>*</span>
                </FormLabel>
                <TextField
                  type="text"
                  variant="outlined"
                  required
                  onChange={(e) =>
                    setExamName(sanitizeInput(e.target.value, "textInput"))
                  }
                  value={examName}
                  placeholder="Type Here"
                />
              </div>
              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
              >
                <FormLabel
                  className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit} ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                >
                  Course <span className={classes.textcolorred}>*</span>
                </FormLabel>

                <Autocomplete
                  multiple
                  id="courses-multiple"
                  options={courses}
                  getOptionLabel={(option) => option.course_name}
                  value={courses.filter((c) => selectedCourse.includes(c.id))}
                  onChange={(event, newValue) =>
                    setSelectedCourse(newValue.map((c) => c.id))
                  }
                  disableClearable
                  forcePopupIcon={false}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      name="courses"
                      type="text"
                      variant="outlined"
                      placeholder="Type to pick..."
                    />
                  )}
                />
              </div>

              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
              >
                <FormLabel
                  className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit} ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                >
                  Batch <span className={classes.textcolorred}>*</span>
                </FormLabel>

                <Autocomplete
                  multiple
                  id="batches-multiple"
                  options={batches}
                  getOptionLabel={(option) => option.batch_name}
                  value={batches.filter((b) => selectedBatch.includes(b.id))}
                  onChange={(event, newValue) =>
                    setSelectedBatch(newValue.map((b) => b.id))
                  }
                  disableClearable
                  forcePopupIcon={false}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      name="batches"
                      type="text"
                      variant="outlined"
                      placeholder="Type to pick..."
                    />
                  )}
                />
              </div>
            </div>
            <div
              className={`${classes.dflex} ${classes.justifyspacebetween} ${classes.mt1} `}
            >
              <Typography
                className={`${classes.w24} ${classes.textcolorformhead} ${classes.fontfamilyoutfit} ${classes.fontsize} ${classes.fontstylenormal} ${classes.fw500} ${classes.lineheight2_25}`}
                variant="h6"
                display="inline"
              ></Typography>
              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w24}`}
              >
                <FormLabel
                  className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                >
                  Faculty <span className={classes.textcolorred}>*</span>
                </FormLabel>

                <Autocomplete
                  multiple
                  id="tags-standard"
                  options={subjects}
                  getOptionLabel={(option) => option.subject_name}
                  value={subjects.filter((sub) =>
                    selectedSubject.includes(sub.id),
                  )}
                  onChange={handleSubjectChange}
                  disableClearable
                  forcePopupIcon={false}
                  renderInput={(params) => (
                    <TextField
                      name="section"
                      type="text"
                      variant="outlined"
                      placeholder="Type to pick..."
                      {...params}
                    />
                  )}
                />
              </div>

              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w24}`}
              >
                <FormLabel
                  className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal}
               ${classes.fw400} ${classes.lineheight}`}
                >
                  Branch Code <span className={classes.textcolorred}>*</span>
                </FormLabel>
                <Autocomplete
                  multiple
                  id="tags-standard"
                  options={center}
                  getOptionLabel={(option) =>
                    `${option.center_code} - ${option.center_name}`
                  }
                  value={center?.filter((sub) =>
                    selectedCenter?.includes(sub.id),
                  )}
                  onChange={handleCenterChange}
                  disableClearable
                  forcePopupIcon={false}
                  renderInput={(params) => (
                    <TextField
                      name="section"
                      type="text"
                      variant="outlined"
                      placeholder="Type to pick..."
                      {...params}
                    />
                  )}
                />
              </div>

              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w24}`}
              >
                <FormLabel
                  className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                >
                  Languages <span className={classes.textcolorred}>*</span>
                </FormLabel>
                <Select
                  labelId="language-label"
                  id="language"
                  multiple
                  open={languageMenuOpen}
                  onOpen={handleLanguageMenuToggle}
                  onClose={handleLanguageMenuToggle}
                  value={formDetails.language}
                  onChange={(e) => {
                    handleFormChange("language", e.target.value);
                    handleLanguageMenuToggle(); // Close the dropdown after selection
                  }}
                  renderValue={(selected) =>
                    selected
                      .map((code) => (code === "en" ? "English" : "Hindi"))
                      .join(", ")
                  }
                  displayEmpty
                  className={classes.selectEmpty}
                  MenuProps={menuProps}
                  variant="outlined"
                >
                  <MenuItem value="hi">Hindi</MenuItem>
                  <MenuItem value="en">English</MenuItem>
                </Select>
              </div>
            </div>

            <div
              className={`${classes.dflex} ${classes.justifyspacebetween} ${classes.mt1} `}
            >
              <Typography
                className={`${classes.w24} ${classes.textcolorformhead} ${classes.fontfamilyoutfit} ${classes.fontsize} ${classes.fontstylenormal} ${classes.fw500} ${classes.lineheight2_25}`}
                variant="h6"
                display="inline"
              ></Typography>

              {/* <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
              >
                <FormLabel
                  className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                >
                  Exam Template <span className={classes.textcolorred}>*</span>
                </FormLabel>

                <Select
                  labelId="category-label"
                  id="state"
                  required
                  value={formDetails.exam_template}
                  onChange={(e) =>
                    handleFormChange("exam_template", e.target.value)
                  }
                  displayEmpty
                  className={classes.selectEmpty}
                  MenuProps={menuProps}
                  variant="outlined"
                >
                  <MenuItem disabled value="">
                    <em className={classes.defaultselect}>Select Here</em>
                  </MenuItem>

                  <MenuItem value={"default"}>Default</MenuItem>
                  <MenuItem value={"ssc/railway"}>IIT</MenuItem>
               
                </Select>
              </div> */}

              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w24}`}
              >
                {/* <FormLabel
                  className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                >
                  Question Shuffle{" "}
                  <span className={classes.textcolorred}>*</span>
                </FormLabel>
                <Select
                  labelId="shuffle-label"
                  id="shuffle"
                  value={formDetails.question_shuffle}
                  onChange={(e) =>
                    handleFormChange("question_shuffle", e.target.value)
                  }
                  displayEmpty
                  className={classes.selectEmpty}
                  MenuProps={menuProps}
                  variant="outlined"
                >
                  <MenuItem disabled value="">
                    <em className={classes.defaultselect}>Select Here</em>
                  </MenuItem>
                  <MenuItem value={"yes"}>Yes</MenuItem>
                  <MenuItem value={"no"}>No</MenuItem>
                </Select> */}
              </div>
              {/* <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w24}`}
              >
                <FormLabel
                  className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                >
                  Marking System{" "}
                </FormLabel>
                <Select
                  labelId="category-label"
                  id="state"
                  required
                  value={formDetails.marking_system}
                  onChange={(e) =>
                    handleFormChange("marking_system", e.target.value)
                  }
                  displayEmpty
                  className={classes.selectEmpty}
                  MenuProps={menuProps}
                  variant="outlined"
                >
                  <MenuItem value="">Select a slot</MenuItem>
                  {examTempalteData?.map((slot, index) => (
                    <MenuItem key={index} value={slot?.id}>
                      {slot?.name}
                    </MenuItem>
                  ))}
                </Select>
              </div> */}

              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
              ></div>
              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
              ></div>
            </div>

            <div
              className={`${classes.dflex} ${classes.justifyspacebetween} ${classes.mt1} `}
            >
              <Typography
                className={`${classes.w24} ${classes.textcolorformhead} ${classes.fontfamilyoutfit} ${classes.fontsize} ${classes.fontstylenormal} ${classes.fw500} ${classes.lineheight2_25}`}
                variant="h6"
                display="inline"
              ></Typography>
              {/* <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w24}`}
              >
                <FormLabel
                  className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                >
                  Parcial Marking{" "}
                  <span className={classes.textcolorred}>*</span>
                </FormLabel>

                <TextField
                  type="number"
                  variant="outlined"
                  onChange={(e) =>
                    handleFormChange("parcial_marking", e.target.value)
                  }
                  value={formDetails.parcial_marking}
                  placeholder="Type Here"
                />
              </div> */}
              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w24}`}
              >
                <FormLabel
                  className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                >
                  Question Count <span className={classes.textcolorred}>*</span>
                </FormLabel>

                <TextField
                  type="number"
                  variant="outlined"
                  onChange={(e) =>
                    handleFormChange("question_count", e.target.value)
                  }
                  value={formDetails.question_count}
                  placeholder="Type Here"
                />
              </div>
              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
              >
                <FormLabel
                  className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                >
                  Total Score <span className={classes.textcolorred}>*</span>
                </FormLabel>
                <TextField
                  type="number"
                  variant="outlined"
                  onChange={(e) =>
                    handleFormChange("total_score", e.target.value)
                  }
                  value={formDetails.total_score}
                  placeholder="Type Here"
                />
              </div>
              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w24}`}
              >
                <FormLabel
                  className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                >
                  Per Question Mark
                </FormLabel>
                <TextField
                  type="text"
                  variant="outlined"
                  value={perQuestionMarks ? `${perQuestionMarks} marks` : "N/A"}
                  disabled
                />
              </div>
            </div>

            <div
              className={` ${classes.w100} ${classes.justifyspacebetween} ${classes.dflex}`}
            >
              <Typography
                className={`${classes.w24} ${classes.textcolorformhead} ${classes.fontfamilyoutfit} ${classes.fontsize} ${classes.fontstylenormal} ${classes.fw500} ${classes.lineheight2_25}`}
                variant="h6"
                display="inline"
              ></Typography>
              <div className={`${classes.w75}`}>
                <div
                  className={`${classes.dflex} ${classes.justifyspacebetween} ${classes.mt1}`}
                >
                  <div
                    className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w32}`}
                  >
                    {/* <FormLabel
                      className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                    >
                      Question Mark System{" "}
                      {console.log("question_mark_system", formDetails)}
                      <span className={classes.textcolorred}>*</span>
                    </FormLabel>
                    <RadioGroup
                      className={`${classes.radiocolor}`}
                      row
                      aria-label="Question Mark System"
                      name="Question Mark System"
                      value={questionMarkSystem}
                      onChange={(e) =>
                        handleFormChange("question_mark_system", e.target.value)
                      }
                    >
                      <FormControlLabel
                        value="same"
                        control={
                          <Radio
                            onClick={() => setQuestionMarkSystem("same")}
                          />
                        }
                        label="Same"
                      />
                      <FormControlLabel
                        value="different"
                        control={
                          <Radio
                            onClick={() => setQuestionMarkSystem("different")}
                          />
                        }
                        label="Different"
                      />
                    </RadioGroup> */}
                  </div>
                  {/* {questionMarkSystem === "same" && (
                    <div
                      className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w32}`}
                    >
                      <FormLabel
                        className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                      >
                        Negative Marking
                        <span className={classes.textcolorred}>*</span>
                      </FormLabel>
                      <Select
                        labelId="negativemarking-label"
                        id="negativemarking"
                        value={formDetails.negative_marking}
                        onChange={(e) =>
                          handleFormChange("negative_marking", e.target.value)
                        }
                        displayEmpty
                        className={classes.selectEmpty}
                        MenuProps={menuProps}
                        variant="outlined"
                      >
                        <MenuItem disabled value="">
                          <em className={classes.defaultselect}>Select Here</em>
                        </MenuItem>
                        <MenuItem value={"yes"}>Yes</MenuItem>
                        <MenuItem value={"no"}>No</MenuItem>
                      </Select>
                    </div>
                  )} */}
                  {/* {questionMarkSystem === "different" && (
                    <div
                      className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w32}`}
                    >
                      <FormLabel
                        className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                      >
                        Negative Marking
                        <span className={classes.textcolorred}>*</span>
                      </FormLabel>
                      <Select
                        labelId="negativemarking-label"
                        id="negativemarking"
                        value="no"
                        onChange={(e) =>
                          handleFormChange("negative_marking", e.target.value)
                        }
                        displayEmpty
                        className={classes.selectEmpty}
                        MenuProps={menuProps}
                        variant="outlined"
                        disabled
                      >
                        <MenuItem disabled value="">
                          <em className={classes.defaultselect}>Select Here</em>
                        </MenuItem>
                        <MenuItem value={"yes"}>Yes</MenuItem>
                        <MenuItem value={"no"}>No</MenuItem>
                      </Select>
                    </div>
                  )} */}
                  {/* {questionMarkSystem === "same" && (
                    <div
                      className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w32}`}
                    >
                      <FormLabel
                        className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                      >
                        Negative Marking Score
                        <span className={classes.textcolorred}>*</span>
                      </FormLabel>
                      <TextField
                        type="float"
                        variant="outlined"
                        required
                        value={
                          formDetails.negative_marking === "no"
                            ? 0
                            : `-${String(
                                formDetails.negative_marking_score,
                              ).replace(/^[-]+/, "")}`
                        }
                        onChange={(e) => {
                          let value = e.target.value.replace(/[^0-9.]/g, "");

                          if (formDetails.negative_marking === "yes") {
                            handleFormChange("negative_marking_score", value);
                          } else {
                            handleFormChange("negative_marking_score", "0");
                          }
                        }}
                        placeholder="Type Here"
                        disabled={formDetails.negative_marking === "no"}
                      />
                    </div>
                  )} */}
                  {questionMarkSystem === "different" && (
                    <div
                      className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w32}`}
                    >
                      <FormLabel
                        className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                      >
                        Negative Marking Score{" "}
                        <span className={classes.textcolorred}>*</span>
                      </FormLabel>
                      <TextField
                        type="number"
                        variant="outlined"
                        required
                        value={
                          questionMarkSystem === "different"
                            ? 0
                            : questionMarkSystem
                        }
                        onChange={(e) =>
                          handleFormChange(
                            "negative_marking_score",
                            e.target.value,
                          )
                        }
                        placeholder="Type Here"
                        disabled
                      />
                    </div>
                  )}
                  {/* {formDetails.negative_marking === "yes" && (
                    <div
                      className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w49}`}
                    >
                      <FormLabel
                        className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                      >
                        Negative Marking Score
                        <span className={classes.textcolorred}>*</span>
                      </FormLabel>
                      <TextField
                        type="float"
                        variant="outlined"
                        required
                        value={
                          questionMarkSystem === "different"
                            ? 0
                            : formDetails.negative_marking_score
                        }
                        onChange={(e) =>
                          handleFormChange(
                            "negative_marking_score",
                            e.target.value
                          )
                        }
                        placeholder="Type Here"
                        disabled={questionMarkSystem === "different"}
                      />
                    </div>
                  )}

                  {formDetails.negative_marking === "no" && (
                    <div
                      className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w49}`}
                    >
                      <FormLabel
                        className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                      >
                        Negative Marking Score{" "}
                        <span className={classes.textcolorred}>*</span>
                      </FormLabel>
                      <TextField
                        type="number"
                        variant="outlined"
                        required
                        value={formDetails.negative_marking_score}
                        onChange={(e) =>
                          handleFormChange(
                            "negative_marking_score",
                            e.target.value
                          )
                        }
                        placeholder="Type Here"
                        disabled
                      />
                    </div>
                  )} */}
                </div>
              </div>
            </div>

            {formDetails.exam_template === "ssc/railway" && (
              <div
                className={`${classes.dflex} ${classes.w100} ${classes.justifyspacebetween} ${classes.mt1} `}
              >
                <Typography
                  className={`${classes.w24} ${classes.textcolorformhead} ${classes.fontfamilyoutfit} ${classes.fontsize} ${classes.fontstylenormal} ${classes.fw500} ${classes.lineheight2_25}`}
                  variant="h6"
                  display="inline"
                ></Typography>
                <div
                  className={`${classes.dflex} ${classes.flexwrapwrap}  ${classes.w75}  ${classes.gap10}`}
                >
                  <div
                    className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w32}`}
                  >
                    <FormLabel
                      className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                    >
                      Subject Wise Submit{" "}
                      <span className={classes.textcolorred}>*</span>
                    </FormLabel>
                    <RadioGroup
                      className={`${classes.radiocolor}`}
                      row
                      aria-label="Question Mark System"
                      name="Question Mark System"
                      value={showSubjectWiseDuration}
                      onChange={handleQuestionMarkSystemChange}
                    >
                      <FormControlLabel
                        value="no"
                        control={<Radio />}
                        label="No"
                      />
                      <FormControlLabel
                        value="yes"
                        control={<Radio />}
                        label="Yes"
                      />
                    </RadioGroup>
                  </div>

                  {showSubjectWiseDuration === "yes" &&
                    subjects
                      .filter((sub) => selectedSubject.includes(sub.id))
                      .map((sub) => (
                        <div
                          key={sub.id}
                          className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w32}`}
                        >
                          <FormLabel
                            className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit} ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                          >
                            {sub.subject_name} Duration{" "}
                            <span className={classes.textcolorred}>*</span>
                          </FormLabel>
                          <TextField
                            type="number"
                            variant="outlined"
                            value={
                              subjectDurations.find(
                                (item) => item.subject_id === sub.id,
                              )?.duration ?? "0"
                            }
                            onChange={(e) =>
                              handleSubjectDurationChange(
                                sub.id,
                                e.target.value,
                              )
                            }
                            placeholder="Type Here"
                          />
                        </div>
                      ))}
                </div>
              </div>
            )}

            <div
              className={` ${classes.w100} ${classes.justifyspacebetween} ${classes.dflex}`}
            >
              <Typography
                className={`${classes.w24} ${classes.textcolorformhead} ${classes.fontfamilyoutfit} ${classes.fontsize} ${classes.fontstylenormal} ${classes.fw500} ${classes.lineheight2_25}`}
                variant="h6"
                display="inline"
              ></Typography>
              <div className={`${classes.w75}`}>
                <div
                  className={`${classes.dflex} ${classes.justifyspacebetween} ${classes.mt1}`}
                >
                  <div
                    className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w32}`}
                  >
                    <FormLabel
                      className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                    >
                      Exam Instant Result{" "}
                      <span className={classes.textcolorred}>*</span>
                    </FormLabel>
                    <Select
                      labelId="exam-instant-result-label"
                      id="exam-instant-result"
                      value={formDetails.exam_instant_result}
                      onChange={(e) =>
                        handleFormChange("exam_instant_result", e.target.value)
                      }
                      displayEmpty
                      className={classes.selectEmpty}
                      MenuProps={menuProps}
                      variant="outlined"
                    >
                      <MenuItem disabled value="">
                        <em className={classes.defaultselect}>Select Here</em>
                      </MenuItem>

                      <MenuItem value={"no"}>No</MenuItem>
                      <MenuItem value={"with_answer"}>With Answers</MenuItem>
                      <MenuItem value={"without_answer"}>
                        Without Answers
                      </MenuItem>
                      {/* <MenuItem value={"section_wise"}>
                        Section Wise Result
                      </MenuItem> */}
                    </Select>
                  </div>

                  <div
                    className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w32}`}
                  >
                    <FormLabel
                      className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                    >
                      Exam PIN <span className={classes.textcolorred}>*</span>
                    </FormLabel>
                    <TextField
                      type="text"
                      variant="outlined"
                      required
                      placeholder="****"
                      value={formDetails.exam_pin}
                      onChange={(e) =>
                        handleFormChange(
                          "exam_pin",
                          sanitizeInput(e.target.value, "numbersOnly"),
                        )
                      }
                      inputProps={{ maxLength: 4 }}
                      error={formDetails.exam_pin.length !== 4}
                      helperText={
                        formDetails.exam_pin.length !== 4
                          ? "Exam PIN must be exactly 4 digits"
                          : ""
                      }
                    />
                  </div>
                  <div
                    className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.mt1_5} ${classes.w32}`}
                  >
                    <Button
                      onClick={handleAutoGeneratePin}
                      className={classes.custombtnblue}
                      disabled={loading}
                    >
                      {loading ? "Generating..." : "Auto Generate"}
                    </Button>
                  </div>
                </div>
              </div>
            </div>

            {/* {formDetails.exam_template === "ssc/railway" && (
              <div
                className={`${classes.dflex} ${classes.justifyspacebetween} ${classes.mt1} `}
              >
                <Typography
                  className={`${classes.w24} ${classes.textcolorformhead} ${classes.fontfamilyoutfit} ${classes.fontsize} ${classes.fontstylenormal} ${classes.fw500} ${classes.lineheight2_25}`}
                  variant="h6"
                  display="inline"
                ></Typography>
                <div
                  className={`${classes.dflex} ${classes.flexwrapwrap}  ${classes.w75}  ${classes.gap10}`}
                >
                  <div
                    className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w32}`}
                  >
                    <FormLabel
                      className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                    >
                      Subject Wise Submit{" "}
                      <span className={classes.textcolorred}>*</span>
                    </FormLabel>
                    <RadioGroup
                      className={`${classes.radiocolor}`}
                      row
                      aria-label="Question Mark System"
                      name="Question Mark System"
                      value={showSubjectWiseDuration}
                      onChange={handleQuestionMarkSystemChange}
                    >
                      <FormControlLabel
                        value="no"
                        control={<Radio />}
                        label="No"
                      />
                      <FormControlLabel
                        value="yes"
                        control={<Radio />}
                        label="Yes"
                      />
                    </RadioGroup>
                  </div>

                  {showSubjectWiseDuration === "yes" &&
                    subjects
                      .filter((sub) => selectedSubject.includes(sub.id))
                      .map((sub) => (
                        <div
                          key={sub.id}
                          className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w32}`}
                        >
                          <FormLabel
                            className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit} ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                          >
                            {sub.subject_name} Duration{" "}
                            <span className={classes.textcolorred}>*</span>
                          </FormLabel>
                          <TextField
                            type="number"
                            variant="outlined"
                            value={
                              subjectDurations.find(
                                (item) => item.subject_id === sub.id
                              )?.duration ?? 0
                            }
                            onChange={(e) =>
                              handleSubjectDurationChange(
                                sub.id,
                                e.target.value
                              )
                            }
                            placeholder="Type Here"
                          />
                        </div>
                      ))}
                </div>
              </div>
            )} */}

            <div
              className={`${classes.dflex} ${classes.mt2}  ${classes.justifyspacebetween} ${classes.mt1} `}
            >
              <Typography
                className={`${classes.w24} ${classes.textcolorformhead} ${classes.fontfamilyoutfit} ${classes.fontsize} ${classes.fontstylenormal} ${classes.fw500} ${classes.lineheight2_25}`}
                variant="h6"
                display="inline"
              ></Typography>
              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w75}`}
              >
                {formDetails.language.map((lang) => (
                  <div key={lang}>
                    <FormLabel>
                      {/* Enter your Genral Instructions for {lang} language: */}
                      Enter your Exam Instructions for {lang} language:
                    </FormLabel>
                    <ReactQuill
                      style={{
                        height: "500px",
                        paddingTop: "1rem",
                        paddingBottom: "3rem",
                      }}
                      value={formDetails.genral_instruction[lang]}
                      onChange={(content) => {
                        setFormDetails((prev) => ({
                          ...prev,
                          genral_instruction: {
                            ...prev.genral_instruction,
                            [lang]: content,
                          },
                        }));
                      }}
                      modules={quillModules}
                      formats={quillFormats}
                    />
                  </div>
                ))}
              </div>
            </div>
            <div
              className={`${classes.dflex} ${classes.mt2}  ${classes.justifyspacebetween} ${classes.mt1} `}
            >
              <Typography
                className={`${classes.w24} ${classes.textcolorformhead} ${classes.fontfamilyoutfit} ${classes.fontsize} ${classes.fontstylenormal} ${classes.fw500} ${classes.lineheight2_25}`}
                variant="h6"
                display="inline"
              ></Typography>
              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w75}`}
              >
                {formDetails.language.map((lang) => (
                  <div key={lang}>
                    <FormLabel>
                      {/* Enter your Exam Instructions for {lang} language: */}
                      Enter your Genral Instructions for {lang} language:
                    </FormLabel>
                    <ReactQuill
                      // readOnly
                      value={formDetails.exam_instructions[lang]}
                      onChange={(content) => {
                        setFormDetails((prev) => ({
                          ...prev,
                          exam_instructions: {
                            ...prev.exam_instructions,
                            [lang]: content,
                          },
                        }));
                      }}
                      readOnly={true}
                      // modules={quillModules}
                      modules={{
                        ...quillModules,
                        toolbar: {
                          ...quillModules.toolbar,
                          container: quillModules.toolbar?.container,
                          handlers: {}, // override all handlers so nothing works
                        },
                      }}
                      formats={quillFormats}
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div
            className={`${classes.bgwhite} ${classes.boxshadow3} ${classes.borderradius6px} ${classes.py2} ${classes.px1_5} ${classes.mt1}`}
          >
            <div className={`${classes.dflex} ${classes.justifyspacebetween} `}>
              <Typography
                className={`${classes.w24} ${classes.textcolorformhead} ${classes.fontfamilyoutfit} ${classes.fontsize} ${classes.fontstylenormal} ${classes.fw500} ${classes.lineheight2_25}`}
                variant="h6"
                display="inline"
              >
                *Other Details
              </Typography>
              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w18}`}
              >
                <FormLabel
                  className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                >
                  Duration in minutes{" "}
                  <span className={classes.textcolorred}>*</span>
                </FormLabel>
                <TextField
                  type="number"
                  variant="outlined"
                  inputProps={{ min: 0 }}
                  required
                  value={formDetails.duration}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (value >= 0) {
                      handleFormChange("duration", value);
                    }
                  }}
                  placeholder="Type Here"
                />
              </div>
              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w18}`}
              >
                <FormLabel
                  className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                >
                  Start Date <span className={classes.textcolorred}>*</span>
                </FormLabel>
                <TextField
                  type="date"
                  variant="outlined"
                  required
                  value={formDetails.start_date}
                  onChange={(e) =>
                    handleFormChange("start_date", e.target.value)
                  }
                  placeholder="Select Date"
                />
              </div>
              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w18}`}
              >
                <FormLabel
                  className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                >
                  Start Time <span className={classes.textcolorred}>*</span>
                </FormLabel>
                <TextField
                  type="time"
                  variant="outlined"
                  required
                  value={formDetails.start_time}
                  onChange={(e) =>
                    handleFormChange("start_time", e.target.value)
                  }
                  placeholder="Type Here"
                />
              </div>
              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w18}`}
              >
                <FormLabel
                  className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                >
                  End Time <span className={classes.textcolorred}>*</span>
                </FormLabel>
                <TextField
                  type="time"
                  variant="outlined"
                  required
                  value={formDetails.end_time}
                  onChange={(e) => handleFormChange("end_time", e.target.value)}
                  placeholder="Type Here"
                  inputProps={{
                    min: formDetails.start_time || undefined,
                  }}
                />
              </div>
            </div>
            {/* <div className={`${classes.dflex} ${classes.justifyspacebetween}`}>
              <Typography
                className={`${classes.w24} ${classes.textcolorformhead} ${classes.fontfamilyoutfit} ${classes.fontsize} ${classes.fontstylenormal} ${classes.fw500} ${classes.lineheight2_25}`}
                variant="h6"
                display="inline"
              ></Typography>
              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w18}`}
              >
                <FormLabel
                  className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit} ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                >
                  Select Slot <span className={classes.textcolorred}>*</span>
                </FormLabel>
                <Select
                  value={formDetails.slot_value}
                  onChange={(e) =>
                    handleFormChange("slot_value", e.target.value)
                  }
                  displayEmpty
                  required
                  variant="outlined"
                >
                  <MenuItem value="" disabled>
                    Select a slot
                  </MenuItem>
                  {slotDropdownFieldData?.centers_slot?.map((slot, index) => (
                    <MenuItem key={index} value={slot?.id}>
                      {slot?.slot_name}
                    </MenuItem>
                  ))}
                </Select>
              </div>
              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
              ></div>
              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
              ></div>
            </div> */}
          </div>
          <div
            className={`${classes.dflex} ${classes.justifyflexend} ${classes.mt1}`}
          >
            <Button
              onClick={handleCancel}
              className={`${classes.custombtnoutline}`}
            >
              Cancel
            </Button>
            <Button
              onClick={handleFormSubmit}
              className={`${classes.custombtnblue}`}
            >
              Submit
            </Button>
          </div>
        </FormControl>
      </div>
    </>
  );
}
export default AddFeedbackForm;
